<template>
  <div class="container">
    <h3 class="heading-tertiary-main">Справочная информация</h3>
    <p class="heading-tertiary-sub">
      Определения и описание логики расчетов модуля FCB Visual Analitycs
    </p>
    <p class="paragraph--small mb-1 reference__wrapper__cuttext">
      <span class="bold">Модуль визуальной аналитики</span> – это аналитический
      BI-инструмент для финансового, нефинансового рынка, а также
      государственных органов, предоставляющий сведения по общей рыночной
      аналитике на базе официальных отчетов, а также по кредитному рынку на
      данных ПКБ в формате:
      <br />
      <br />
      А) рынок (для консультантов и некредитных организаций) <br />
      Б) финансовый институт VS рынок (для кредитных организаций)<br />
      В) демо версии отчетов Demo (содержат тестовую информацию для новых
      пользователей, желающих ознакомиться с модулем визуальной аналитики)
    </p>
    <div class="reference" v-if="reports">
      <!-- <ReferenceFilterList></ReferenceFilterList>
      <GlossaryFilterList></GlossaryFilterList> -->
      <div
        class="reference__accordion"
        v-for="(report, index) in reports.data"
        :key="report.id"
      >
        <div
          class="accordion__item accordion__item--main"
          @click="toggleAccordion(index)"
        >
          <div class="accordion__item-wrapper">
            <!-- <img :src="require(`../../assets/icons/${item.icon}.svg`)" class="accordion__icon" alt=""> -->
            <img :src="getIcon(report.image)" class="accordion__icon" alt="" />
            <p class="accordion__title--secondary bold">{{ report.name }}</p>
            <img
              class="accordion__icon--down"
              src="../../assets/icons/arrow-down.svg"
              :class="{
                'accordion__item--open':
                  contentVisible && selectedIndex === index,
              }"
              alt=""
            />
          </div>
        </div>
        <div
          class="accordion__item accordion__item--sub accordion__item--readOnly"
          v-if="contentVisible && selectedIndex === index"
          v-html="report.description"
        ></div>
      </div>
    </div>
    <div v-else-if="error">
      <ReferenceFilterList></ReferenceFilterList>
      <GlossaryFilterList></GlossaryFilterList>
    </div>
    <p class="mb--10 mt--3 bold">
      ПКБ не несет ответственности за решения, принятые пользователями на
      основании данных FCB Visual Analytics.
    </p>
  </div>
</template>

<script>
import ReferenceFilterList from "@/views/reference/components/ReferenceFilterList.vue";
import GlossaryFilterList from "@/views/reference/components/GlossaryFilterList.vue";
import { actionTypes } from "@/store/modules/report";
import { mapState } from "vuex";
export default {
  components: {
    ReferenceFilterList,
    GlossaryFilterList,
  },
  data() {
    return {
      selectedIndex: null,
      contentVisible: false,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.report.isLoading,
      reports: (state) => state.report.data,
      error: (state) => state.report.error,
    }),
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    getReportList() {
      this.$store.dispatch(actionTypes.getReportReferenceAction);
    },
    toggleAccordion(index) {
      if (this.selectedIndex !== index) {
        this.contentVisible = true;
        this.selectedIndex = index;
      } else {
        this.selectedIndex = index;
        this.contentVisible = !this.contentVisible;
      }
    },
    getIcon(image_name) {
      return "/media/" + image_name;
    },
  },
};
</script>

<style lang="scss" scoped>
.reference {
  &__accordion {
    background: #f1f9ff;
    &:nth-child(even) {
      background-color: transparent;
    }
  }
  &__wrapper {
    max-width: 1110px;
    width: 100%;
    padding: 0 45px;
    margin: auto;
    &__cuttext {
      width: 100%;
    }
  }
}
.accordion {
  &__item {
    padding: 2rem;
    //height: 6.3rem;
    cursor: pointer;
    &--readOnly {
      cursor: auto;
    }
    &--open {
      transform: rotate(180deg);
    }
    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    &--sub {
      height: auto;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      padding-left: 8rem;
      font-size: 16px;
    }
    &--main {
    }
  }
  &__icon {
    width: 3rem;
    height: 3rem;
    &--down {
    }
  }
  &__title {
    color: #005177;
    font-size: 14px;
    display: flex;
    align-items: center;
    &--secondary {
      margin-left: 3.1rem;
      width: 100%;
      font-size: 16px;
    }
  }
}
</style>
